export default __webpack_public_path__ + "static/media/timelineOpportunityArchived.7058eab0.svg";